import { render, staticRenderFns } from "./LicitacaoFornecedorAcoesEnviar.vue?vue&type=template&id=0c838b6b&scoped=true"
import script from "./LicitacaoFornecedorAcoesEnviar.vue?vue&type=script&lang=js"
export * from "./LicitacaoFornecedorAcoesEnviar.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoFornecedorAcoesEnviar.vue?vue&type=style&index=0&id=0c838b6b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c838b6b",
  null
  
)

export default component.exports